module.exports = {
      id: "apple-usage",
      viewBox: "0 0 56 56",
      url: __webpack_public_path__ + "svg-sprite-8e03654a4a2895e52544254db36238f1.svg#apple",
      toString: function () {
        return this.url;
      }
    }